import $ from "jquery";
import {normalize, onClick, createSVGElement, isMobile} from './Helper';
import Chart from "chart.js";
import {gsap, TweenLite} from 'gsap';
import Draggable from 'gsap/Draggable.js';

gsap.registerPlugin(Draggable);

let restrict_swipe = false;

function Infobox(options) {
    this.map = options.map;
    this.menu = options.menu;

    this.img_size = options.img_size;
    this.img_mode = 'portrait';

    this.twitter_mode = options.twitter_mode;
    this.flyto_target = true;

    this.events = {};

    this.container = $(document.getElementById(options.container));
    this.content = $(document.getElementById(options.content));
    this.wheel = document.getElementById(options.wheel);

    this.closeButton = $(document.getElementById(options.closeButton));
    this.mapOverlay = $(document.getElementById(options.mapOverlay));

    this.current = null;
    this.target = null;

    this.isCards = true;

    this.wheelTabs = [];
    this.draggable = undefined;

    this.init(100, 20);

    this.pieChart = new PieChart();

    this.resize();
}

Infobox.prototype.init = function (r, n) {
    let infobox = this;

    let step = 360 / n;
    let size = r + 10;

    let content = createSVGElement('svg', {
        'id': 'wheel-content',
        'viewBox': (-size) + ' ' + (-size) + ' ' + (2 * size) + ' ' + (2 * size)
    });

    content.appendChild(createSVGElement('circle', {
        'class': 'wheel-trigger',
        'r': 100,
        'fill': 'white'
    }));

    for (let i = 0; i < n; i++) {
        let tab = createSVGElement('g', {
            'id': 'tab_' + i,
            'class': 'tab wheel-trigger',
            'transform': 'rotate(' + (step * i - 90) + '), translate(' + r + ', 0), rotate(90)'
        });

        content.appendChild(tab);
        infobox.wheelTabs.push(tab);
    }

    infobox.wheel.appendChild(content);

    infobox.draggable = Draggable.create(infobox.wheel, {
        type: "rotation",
        trigger: '.wheel-trigger',
        svgOrigin: size + ' ' + size,
        minimumMovement: 0,
        onRelease: function () {
            if (infobox.current) {
                let currentIndex = (infobox.current.index === false) ? 0 : infobox.current.index;

                infobox.rotate(-(Math.round((this.rotation / step + currentIndex) * 1.5)));
            }

            TweenLite.to(infobox.content, 0.5, {
                ease: "power2.out",
                y: 0
            });
        },
        onDrag: function () {
            if (infobox.current) {
                let currentIndex = (infobox.current.index === false) ? 0 : infobox.current.index;

                TweenLite.to(infobox.content, 0, {
                    y: Math.pow(Math.abs(this.rotation / step + currentIndex) * 3, 4) * 1000,
                });
            }
        }
    })[0];

    onClick(infobox.closeButton, function () {
        infobox.close();
    });
};

Infobox.prototype.registerEvents = function (events) {
    this.events = events;

    Object.keys(events).forEach(function (key) {
        onClick(key, events[key]);
    });
};

Infobox.prototype.state = function (type, id, filter, callback) {
    callback = typeof callback === 'undefined' ? null : callback;
    let state = new State(this.map, this.current, null);

    state.type = type;
    state.id = id;

    state._filter = filter.map(function (f) {
        return f.toString();
    });
    state._index = state._filter.indexOf(id.toString());

    this.ajax(state.setTwitterMode(this.twitter_mode), callback);
};

Infobox.prototype.close = function () {
    let infobox = this;

    if (infobox.current) {
        infobox.map.highlightStimmkreis(-1);
    }

    infobox.current = null;
    infobox.target = null;

    infobox.container.removeClass("open");
    infobox.closeButton.stop().fadeOut(1000);

    window.scrollTo(0, 0);
    $("body").addClass("no-scroll");

    $(".filter").stop().fadeOut(1000);

    infobox.mapOverlay.stop().fadeOut(1500);
    infobox.mapOverlay.css('pointer-events', 'none');
};

Infobox.prototype.open = function (state) {
    let infobox = this;
    if (state && state.flyto_target !== false) {
        switch (state.type) {
            case "stimmkreis":
                this.map.highlightStimmkreis(state.id);
                break;

            case "wahlkreis":
                this.map.highlightWahlkreis(state.id);
                break;

            case"abgeordneter":
                this.map.highlightAbgeordneter(state.id);
                break;
        }
    }
    state.flyto_target = true;

    infobox.current = state;
    infobox.target = state;

    infobox.container.addClass("open");
    infobox.closeButton.stop().fadeIn(1000);

    $("body").removeClass("no-scroll");

    $(".filter").stop().fadeIn(1000);

    if (infobox.current.prev === null) {
        $('.back-infobox').hide();
    } else {
        $('.back-infobox').show();
    }

    if (isMobile()) {
        if (infobox.menu.isOpen()) {
            infobox.menu.close();
        }

        infobox.mapOverlay.stop().fadeIn(1500);
        infobox.mapOverlay.css('pointer-events', 'auto');

        if (!$('#swipe-gesture').hasClass("hide")) {
            $('#swipe-gesture').show();

            setTimeout(function () {
                $('#swipe-gesture').fadeOut(1000);
                $('#swipe-gesture').addClass("hide");
            }, 6000);
        }
    }

    if (infobox.isCards) {
        infobox.cards();
    } else {
        infobox.list();
    }
};

Infobox.prototype.isOpen = function () {
    return this.container.hasClass("open");
};

Infobox.prototype.list = function () {
    $(".icon-list-cards.active").removeClass("active");
    $(".icon-list").addClass("active");
    $(".list-cards").removeClass("show");
    $(".list").addClass("show");

    this.isCards = false;
};

Infobox.prototype.cards = function () {
    $(".icon-list.active").removeClass("active");
    $(".icon-list-cards").addClass("active");
    $(".list-cards").addClass("show");
    $(".list").removeClass("show");

    this.isCards = true;
};

Infobox.prototype.rotate = function (dist) {
    if (Math.abs(dist) > 0) {
        dist /= Math.abs(dist);
    }

    if (this.target !== null) {
        let target = this.target.get(dist);
        let rotation = 0;

        if (target) {
            rotation = -target.index * 360 / this.wheelTabs.length;

            this.ajax(target, null);
        }

        TweenLite.to(this.wheel, 0.5, {
            ease: "power2.out",
            rotation: rotation,
        });
    }
};

Infobox.prototype.back = function () { //TODO check if needed
    if (this.target !== null) {
        this.ajax(this.target.prev, null);
    }
};

Infobox.prototype.update = function (state) {
    let infobox = this;

    if (state) {
        infobox.content.html(state.data);
        infobox.container.scrollTop(0);

        if (state.type === "abgeordneter") {
            let tweets = infobox.map.abgeordnete[state.id].tweets.infobox;
            let screen_name = infobox.map.abgeordnete[state.id].tweets.screen_name;

            if (tweets === null) {
                $("a[href='#tweets']").hide();
            }

            if (state.twitter_mode) {
                $("#tweets").html(tweets);
                $("#screen_name").html(screen_name);
            }
        }

        if (isMobile()) {
            $('#image').hide();
        }

        if (state.prev !== null) {
            $('.back-infobox').hide(); //TODO find if in use
        }

        let rotation = 0;

        if (state.index !== false) {
            infobox.softload(state, [-1, 0, 1], false);

            rotation = -state.index * 360 / infobox.wheelTabs.length;
        } else {
            infobox.softload(state, [0], false);
        }

        TweenLite.set(infobox.wheel, {rotation: rotation});
        infobox.draggable.update();

        $('.pie-chart').each(function () {
            infobox.pieChart.drawChart(this, this.dataset.type, JSON.parse(this.dataset.data), JSON.parse(this.dataset.fraktionen));
        });

        infobox.open(state);
    } else {
        infobox.close();
    }

    let events = this.events;

    Object.keys(events).forEach(function (key) {
        onClick(key, events[key]);
    });
};

Infobox.prototype.resize = function () {
    if (isMobile()) {
        $('#image').hide();
        $(this.wheel).show();
        $('.wheel-trigger').show();

        if (this.menu.isOpen()) {
            this.menu.hideInfobox();
        }

        let paddingTop;

        if ($(window).width() > $(window).height()) {
            this.img_mode = 'landscape';

            paddingTop = 25 + 0.35 * $(window).width() + 'px';
        } else {
            this.img_mode = 'portrait';

            paddingTop = 50 + 0.4 * $(window).width() + 'px';
        }

        this.container[0].style.paddingTop = paddingTop;

        this.softclear();

        if (this.current) {
            this.mapOverlay.stop().fadeIn(1500);
            this.mapOverlay.css('pointer-events', 'auto');

            this.softload(this.current, [-1, 0, 1], true);
        }
    } else {
        $('#image').show();
        $(this.wheel).hide();
        $('.wheel-trigger').hide();

        this.container[0].style.paddingTop = 0 + 'px';

        this.mapOverlay.stop().fadeOut(1500);
        this.mapOverlay.css('pointer-events', 'none');
    }

    document.getElementById('wheel-content').style.width = 5 * $(window).width() + 'px';
};

Infobox.prototype.ajax = function (state, callback) {
    callback = typeof callback === 'undefined' ? null : callback;
    let infobox = this;

    infobox.target = state;
    if (!state.eq(infobox.current)) {
        $.ajax({
            url: 'infobox.php?type=' + encodeURI(state.type) + '&id=' + encodeURI(state.id) + (state.twitter_mode ? '&version=twitter' : ''),
            success: function (data) {
                state.data = data;

                infobox.update(state);

                if (callback !== null) {
                    callback();
                }
            }
        });
    }
};

Infobox.prototype.softload = function (state, diff, force) {
    diff = (typeof diff === 'undefined' || diff === null) ? [0] : diff;
    force = (typeof force === 'undefined' || force === null) ? false : force;

    let infobox = this;

    let whitelist = [];

    diff.forEach(function (diff) {
        let id = state.id;
        let cur = state.get(diff);
        let tab = infobox.wheelTabs[0];

        if (cur) {
            id = cur.id;
            tab = infobox.wheelTabs[normalize(state.index + diff, infobox.wheelTabs.length)];
        }

        whitelist.push(tab);

        if (tab.getAttribute('data-type') !== state.type || tab.getAttribute('data-id') !== id || force) {
            let group = createSVGElement('g', {});
            let url = 'image.php?type=' + encodeURI(state.type) + '&id=' + encodeURI(id);

            if (state.type === "abgeordneter") {
                group.appendChild(createSVGElement('rect', {
                    'x': -infobox.img_size[infobox.img_mode][0] / 2 - 1,
                    'y': -infobox.img_size[infobox.img_mode][1] / 2 - 1,
                    'width': infobox.img_size[infobox.img_mode][0] + 2,
                    'height': infobox.img_size[infobox.img_mode][1] + 2,
                    'fill': "#FFFFFF"
                }));

                group.appendChild(createSVGElement('image', {
                    'x': -infobox.img_size[infobox.img_mode][0] / 2,
                    'y': -infobox.img_size[infobox.img_mode][1] / 2,
                    'width': infobox.img_size[infobox.img_mode][0],
                    'height': infobox.img_size[infobox.img_mode][1],
                    'href': url,
                    'preserveAspectRatio': "none"
                }));
            } else {
                group.appendChild(createSVGElement('circle', {
                    'cx': 0,
                    'cy': 8,
                    'r': 12,
                    'fill': "#FFFFFF"
                }));

                group.appendChild(createSVGElement('image', {
                    'x': -6,
                    'y': -2,
                    'width': 12,
                    'height': 8,
                    'href': url
                }));
            }

            tab.setAttribute('data-type', state.type);
            tab.setAttribute('data-id', id);

            tab.innerHTML = group.outerHTML;
        }
    });

    infobox.wheelTabs.forEach(function (tab) {
        if (whitelist.indexOf(tab) < 0) {
            $(tab).hide();
        } else {
            $(tab).show();
        }
    });
};

Infobox.prototype.softclear = function () {
    let infobox = this;

    infobox.wheelTabs.forEach(function (tab) {
        tab.setAttribute('data-type', null);
        tab.setAttribute('data-id', null);

        tab.innerHTML = '';
    });
};

function State(map, prev, copy) {
    copy = typeof copy === 'undefined' ? null : copy;
    this.prev = prev;

    this.type = copy ? copy.type : null;
    this.id = copy ? copy.id : null;

    this._filter = copy ? copy._filter : [];
    this._index = copy ? copy._index : -1;

    this.twitter_mode = copy ? copy.twitter_mode : false;

    this.filter = copy ? copy.filter : [];
    this.index = copy ? copy.index : -1;

    this.map = map;

    this.data = "";
}

State.prototype.setTwitterMode = function (twitter_mode) {
    if (restrict_swipe && twitter_mode && this.twitter_mode !== twitter_mode && this.type === 'abgeordneter') {
        let whitelist = this.map.getAbgeordnetenKeys(twitter_mode);

        this.filter = this._filter.filter(function (item) {
            return (whitelist.indexOf(item) > -1);
        });
        this.index = this.filter.indexOf(this.id);
    } else {
        this.filter = this._filter;
        this.index = this._index;
    }

    this.twitter_mode = twitter_mode;

    if (this.index === -1) {
        this.index = false;
    }

    return this;
};

State.prototype.get = function (dist) {
    if (this.index === false) {
        return false;
    }

    let state = new State(this.map, this.prev, this);

    state.index = state.index + dist;
    state.id = state.filter[normalize(state.index, state.filter.length)];

    state._index = state._filter.indexOf(state.id);

    return state;
};

State.prototype.eq = function (state) {
    if (state === null) {
        return false;
    }

    return this.type === state.type
        && this.id === state.id
        && JSON.stringify(this.filter) === JSON.stringify(state.filter)
        && this.index === state.index
        && this.twitter_mode === state.twitter_mode;
};

function PieChart() {
    this.defaultChartArgs = {
        type: 'pie',
        data: null,
        options: {
            segmentShowStroke: false,
            animateRotate: false,
            animation: false,
            percentageInnerCutout: 0,
            legend: {
                display: false
            },
            elements: {
                arc: {
                    borderWidth: 0
                }
            },
            tooltips: {
                enabled: true,
                mode: 'single',
                callbacks: {
                    label: function (tooltipItem, data) {
                        return data.labels[tooltipItem.index] + ": " + Math.round(data.datasets[0].data[tooltipItem.index] * 10) / 10 + "%";
                    }
                }
            }
        }
    };
}

PieChart.prototype.getKreisData = function (data, fraktionen) {
    let mydata = [];

    $.each(fraktionen, function (id, item) {
        item.value = data[id] / data['gueltig'] * 100;
        mydata.push(item);
    });

    return mydata;
};

PieChart.prototype.drawChart = function (element, type, data, fraktionen) {
    if (element === null) {
        return null;
    }

    let mydata = this.getKreisData(data, fraktionen);

    let ctx = element.getContext("2d");
    let chartArgs = $.extend(true, {}, this.defaultChartArgs);
    chartArgs['data'] = this.mapChartData(mydata);

    return new Chart(ctx, chartArgs);
};

PieChart.prototype.mapChartData = function (mydata) {
    let data = {
        labels: [],
        datasets: [
            {
                data: [],
                backgroundColor: [],
                hoverBackgroundColor: []
            }]
    };

    for (let i = 0; i < mydata.length; i++) {
        let obj = mydata[i];
        data.labels.push(obj.name);
        data.datasets[0].data.push(obj.value);
        data.datasets[0].backgroundColor.push(obj.farbe);
        data.datasets[0].hoverBackgroundColor.push(obj.farbe);
    }

    return data;
};

export {Infobox, State}
